import { styled } from '@porsche-code/kado-styled-system/jsx';

export const Center = styled('div', {
  base: {
    display: 'grid',
    justifyItems: 'center',
    alignContent: 'center',
    gap: 'md',
  },
});
